var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconContent = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 18C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20H20C19.4477 20 19 19.5523 19 19C19 18.4477 19.4477 18 20 18H21ZM16 18C16.5523 18 17 18.4477 17 19C17 19.5523 16.5523 20 16 20H15C14.4477 20 14 19.5523 14 19C14 18.4477 14.4477 18 15 18H16ZM11 18C11.5523 18 12 18.4477 12 19C12 19.5523 11.5523 20 11 20H4C3.44772 20 3 19.5523 3 19C3 18.4477 3.44772 18 4 18H11ZM21 14C21.5523 14 22 14.4477 22 15C22 15.5523 21.5523 16 21 16H4C3.44772 16 3 15.5523 3 15C3 14.4477 3.44772 14 4 14H21ZM10 3C11.1046 3 12 3.89543 12 5V10C12 11.1046 11.1046 12 10 12H5C3.89543 12 3 11.1046 3 10V5C3 3.89543 3.89543 3 5 3H10ZM21 8C21.5523 8 22 8.44772 22 9C22 9.55228 21.5523 10 21 10H15C14.4477 10 14 9.55228 14 9C14 8.44772 14.4477 8 15 8H21ZM10 5H5V10H10V5ZM21 4C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H15C14.4477 6 14 5.55228 14 5C14 4.44772 14.4477 4 15 4H21Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconContent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconContent.6883d1e38a57837cf58c9a501834236d.svg";